const EVENT_TYPE = {
  EVENTS: 1,
  PROJECTS: 7,
  TASKS: 2,
};

const TASK_STATUSES = {
  BACKLOG: 0,
  QUEUE: 1,
  REJECTED: 2,
  CREATED: 3,
  IN_PROGRESS: 4,
  COMPLETED: 5,
  TURNED_IN: 6,
};

const DUE_OPTIONS = [
  {
    id: 'today',
    due_description: 'DUE TODAY',
  },
  {
    id: 'week',
    due_description: 'DUE THIS WEEK',
  },
  {
    id: 'month',
    due_description: 'DUE THIS MONTH',
  },
  {
    id: 'other',
    due_description: 'ALL TASKS',
  },
];

const BASIC_STRUCTURE = { tasks: { today: [], week: [], month: [], other: [] } };

const TASK_REPEAT_OPTIONS = {
  DOES_NOT_REPEAT: '1',
  DAILY: '2',
  WEEKLY: '3',
  MONTHLY: '4',
};

export { EVENT_TYPE, TASK_STATUSES, DUE_OPTIONS, BASIC_STRUCTURE, TASK_REPEAT_OPTIONS };
